<div class="row h-100">
  <section class="col-md-4 pe-2 mt-2">
    <i-title [text]="'Contacts'" level="1" class="me-3 mb-3" [buttons]="titleButtons"></i-title>
    <div class="d-flex align-items-center justify-content-between mb-3 mt-1">
      <div class="p-fluid">
        <p-dropdown
          [options]="contactsTypes | sort: 'label' : 'ASC'"
          placeholder="Tous les types"
          [showClear]="true"
          appendTo="body"
          [(ngModel)]="typeContact">
        </p-dropdown>
      </div>
      <div class="ms-2 p-fluid">
        <p-dropdown
          [options]="typeContactLV | sort: 'label' : 'ASC'"
          placeholder="Tous les statuts"
          [showClear]="true"
          appendTo="body"
          [(ngModel)]="typeSociete"
          id="selectStatut"></p-dropdown>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-center mb-2">
      <i-button
        pTooltip="Recherche avancée sur les contacts"
        text="Recherche Avancée"
        tooltipPosition="right"
        appendTo="body"
        icon="bi bi-search"
        styleClass="blue me-3"
        size="small"
        (click)="openSearchModal = true"></i-button>

      <i-button
        pTooltip="Réinitialiser tout les filtres"
        text="Réinitialiser les filtres"
        tooltipPosition="right"
        appendTo="body"
        styleClass="red"
        size="small"
        (click)="reinit()"></i-button>
    </div>
    @if (noResults) {
      <div class="alert alert-warning mb-3 mt-3" role="alert">Il n'y a pas de résultats pour votre recherche</div>
    }
    <app-super-contact-list
      [items]="contacts | filter: 'typeContactID' : typeContact | filter: 'typeSocieteString' : typeSociete"
      (selectedValue)="receive_selected($event)"
      (scrollEvent)="receiveScrollE($event)"
      [triggerSearch]="triggerSearch"
      (searchEvent)="receiveSearchEvent($event)"
      [active]="active"
      [click]="getUserData"
      [searchs]="searchString"></app-super-contact-list>
    <!-- </div> -->

    @if (searchLoaded === false) {
      <div class="d-flex flex-column align-items-center justify-content-center mt-4">
        <p-progressSpinner stroke="2"></p-progressSpinner>
        <p class="d-block">{{ 'contactsDetails.searchingContacts' | translate }}</p>
      </div>
    }
  </section>

  <section class="col-md-8">
    <router-outlet></router-outlet>
  </section>
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
    <p style="color: white">Chargement...</p>
  </ngx-spinner>
</div>

<p-dialog
  styleClass="super-compos-modal-content modal-scss"
  header="Recherche avancée sur les contacts"
  [(visible)]="openSearchModal"
  [modal]="true"
  appendTo="body"
  [style]="{ width: '60vw' }">
  <form class="row" [formGroup]="formSearch" autocomplete="false | unknown-autocomplete-value">
    <div class="col-md-4 mb-3">
      <label class="super-compos-label-input">Nom</label>
      <i-input
        [iInput]="{ placeholder: 'editCourrier.lastName' | translate }"
        [type]="'text'"
        [control]="formSearch.get('nom')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </div>
    <div class="col-md-4 mb-3">
      <label class="super-compos-label-input">Prénom</label>
      <i-input
        [iInput]="{ placeholder: 'editCourrier.firstName' | translate }"
        [type]="'text'"
        [control]="formSearch.get('prenom')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </div>
    <div class="col-md-4 mb-3">
      <label class="super-compos-label-input">TVA</label>
      <i-input
        [iInput]="{ placeholder: 'Ex: BE18181818' }"
        [type]="'text'"
        [control]="formSearch.get('tva')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </div>

    <div class="col-md-4 mb-3">
      <label class="super-compos-label-input">Localité</label>
      <p-dropdown
        [options]="localitiesLV"
        [filter]="true"
        placeholder="Ex: Liège"
        styleClass="w-100"
        [showClear]="true"
        appendTo="body"
        formControlName="localite"
        (onChange)="onSelectLocality($event)"
        autocomplete="new-password"></p-dropdown>
    </div>
    <div class="col-md-4 mb-3">
      <label class="super-compos-label-input d-block">Code postal</label>
      <p-dropdown
        [options]="postalCodesLV"
        [filter]="true"
        [disabled]="!formSearch.value.localite"
        placeholder="Sélectionnez une localité"
        styleClass="w-100"
        [showClear]="true"
        appendTo="body"
        formControlName="cp"
        (onChange)="onSelectPostalCode($event)"
        autocomplete="new-password"></p-dropdown>
    </div>
    <div class="col-md-4 mb-3">
      <label class="super-compos-label-input">Adresse principale</label>
      <div class="d-flex flex-row">
        <div style="width: 14.25rem">
          <p-dropdown
            [options]="streetsLV"
            [filter]="true"
            [disabled]="!formSearch.value.cp"
            placeholder="Sélectionnez un code postal"
            styleClass="w-100"
            [showClear]="true"
            appendTo="body"
            (onChange)="onSelectStreet($event)"
            autocomplete="new-password">
            <ng-template let-item pTemplate="selectedItem"
              ><span [ngStyle]="{ color: '#24344b' }">{{ item?.label }}</span></ng-template
            >
          </p-dropdown>
        </div>
        <div style="width: 6.75rem; margin-left: auto">
          <p-dropdown
            [options]="streetNumbersLV"
            [filter]="true"
            [disabled]="!formSearch.value.rue || streetNumbersLoading"
            placeholder="N°"
            [showClear]="true"
            styleClass="w-100"
            appendTo="body"
            formControlName="streetNumber"
            (onChange)="onSelectStreetNumber($event)"
            autocomplete="new-password">
            <ng-template let-item pTemplate="selectedItem"
              ><span [ngStyle]="{ color: '#24344b' }">{{ item?.label }}</span></ng-template
            >
          </p-dropdown>
        </div>
      </div>
    </div>
    <div class="col-md-4 mb-3">
      <label class="super-compos-label-input">{{ clientType === 'JVS' ? 'Tel. portable' : 'GSM' }}</label>
      <i-input
        [iInput]="{ placeholder: 'Ex: +3249356211' }"
        [type]="'text'"
        [control]="formSearch.get('gsm')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </div>
    <div class="col-md-4 mb-3">
      <label class="super-compos-label-input">Email</label>
      <input type="mail" formControlName="email" class="form-control" placeholder="Ex: mail@me.be" autocomplete="new-password" />
    </div>
    <div class="col-md-4 mb-3">
      <label class="super-compos-label-input d-block">Titre</label>
      <p-dropdown
        [options]="contactTitles"
        [filter]="true"
        placeholder="Titre"
        styleClass="w-100"
        [showClear]="true"
        appendTo="body"
        formControlName="titre"
        autocomplete="new-password"></p-dropdown>
    </div>
    <div class="col-md-4 mb-3">
      <label class="super-compos-label-input d-block">Langue</label>
      <p-dropdown
        [options]="langues"
        [filter]="true"
        styleClass="w-100"
        placeholder="Langue"
        [showClear]="true"
        appendTo="body"
        formControlName="langueID"
        id="langueId"
        autocomplete="new-password"></p-dropdown>
    </div>
    <div class="col-md-4">
      <label class="super-compos-label-input d-block">Type</label>
      <p-dropdown
        [options]="contactsTypes"
        [filter]="true"
        styleClass="w-100"
        placeholder="Type de contact"
        [showClear]="true"
        appendTo="body"
        formControlName="contactTypeId"
        id="typeContactID"
        autocomplete="new-password"></p-dropdown>
    </div>
    <div class="col-md-4">
      <label class="super-compos-label-input d-block">Nationalité</label>
      <p-dropdown
        [options]="nationalites"
        [filter]="true"
        styleClass="w-100"
        placeholder="Nationalité du contact"
        appendTo="body"
        [showClear]="true"
        formControlName="nationalite"
        id="nationalite"
        autocomplete="new-password">
        <ng-template let-item pTemplate="selectedItem"
          ><span [ngStyle]="{ color: '#24344b' }">{{ item?.label }}</span></ng-template
        >
      </p-dropdown>
    </div>
  </form>
  <i-button text="Réinitialiser la recherche" styleClass="bottomButton red mb-3" (click)="reinit()" id="reinitField"></i-button>
  <i-button text="Rechercher" styleClass="bottomButton blue" (click)="searchAdvanced()"></i-button>
</p-dialog>
